/** News older than this is omitted from listings and returns HTTP 410 on /news/{slug}. */
export const NEWS_RETENTION_YEARS = 2

/**
 * Cutoff instant: 2 calendar years before `referenceDate`.
 * Uses the Node process timezone (same as dashboard year/month filters).
 */
export function getNewsRetentionCutoff(referenceDate = new Date()) {
  const cutoff = new Date(referenceDate.getTime())
  cutoff.setFullYear(cutoff.getFullYear() - NEWS_RETENTION_YEARS)
  return cutoff
}

/** publishedDate, then createdAt — same effective date as public cards/meta. */
export function getNewsEffectiveDate(news) {
  return news?.publishedDate || news?.createdAt || null
}

/**
 * True when the article exists and its effective date is older than the cutoff.
 * Missing dates are not treated as expired. Future dates are not expired.
 */
export function isNewsExpired(news, referenceDate = new Date()) {
  const effective = getNewsEffectiveDate(news)
  if (!effective) return false
  return new Date(effective) < getNewsRetentionCutoff(referenceDate)
}

export function newsGoneHtml() {
  return `<!DOCTYPE html>
<html lang="mr">
<head>
  <meta charset="utf-8"/>
  <meta name="robots" content="noindex, nofollow"/>
  <title>410 — ही बातमी आता उपलब्ध नाही</title>
</head>
<body>
  <main style="font-family:sans-serif;text-align:center;padding:80px 16px">
    <h1>410 — ही बातमी आता उपलब्ध नाही.</h1>
    <p>ही बातमी आता प्रकाशित नाही. कृपया नवीन बातम्या पाहण्यासाठी मुख्यपृष्ठावर जा.</p>
    <p><a href="/">मुख्यपृष्ठावर परत जा</a></p>
  </main>
</body>
</html>`
}
